{
  "familyId": "TAA-LEZEN-FEIT",
  "questions": [
    {
      "id": "TAA-LEZEN-FEIT-001",
      "familyId": "TAA-LEZEN-FEIT",
      "module": "Taalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_feit_mening",
      "questionType": "multiple_choice",
      "question": "Een journalist schrijft over sport. Welke zin is een mening?",
      "options": ["Voetbal is de leukste sport die er bestaat.", "Een voetbalwedstrijd duurt 90 minuten.", "Het WK voetbal is in 2022 gehouden in Qatar.", "Een voetbalteam bestaat uit 11 spelers."],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Feit of mening?", "content": "Een mening is iets wat niet voor iedereen geldt en niet bewezen kan worden. Signaalwoorden: 'de leukste', 'de beste', 'ik vind'. Een feit is controleerbaar.", "icon": "lightbulb" } }],
      "conceptId": "fact_opinion_distinction",
      "variantIndex": 1,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "FEIT-MENING-REGELS-ZIJN-FEITEN", "optionIndex": 1, "label": "Verwart spelregels (feiten) met meningen" },
          { "id": "FEIT-MENING-HISTORIE-IS-FEIT", "optionIndex": 2, "label": "Verwart historische feiten met meningen" },
          { "id": "FEIT-MENING-AANTALLEN-ZIJN-FEITEN", "optionIndex": 3, "label": "Verwart controleerbare aantallen met meningen" }
        ]
      },
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "De journalist herkent: een feit is controleerbaar en objectief. Een mening is subjectief en bevat een waardeoordeel. 'De leukste sport' bevat de overtreffende trap → waardeoordeel → mening. Niet iedereen vindt voetbal de leukste sport.",
        "solutionSteps": ["Zoek signaalwoorden voor meningen: overtreffende trap ('de leukste', 'de beste'), 'ik vind'", "'De leukste sport' bevat de overtreffende trap", "Overtreffende trap = waardeoordeel = mening", "De andere zinnen bevatten controleerbare feiten"],
        "distractorExplanations": {
          "0": "Goed! 'De leukste sport' is een waardeoordeel (overtreffende trap) → mening.",
          "1": "Je dacht waarschijnlijk dat dit een mening is. Maar 'een voetbalwedstrijd duurt 90 minuten' is een controleerbaar feit — het staat in de spelregels. Onthoud: als je het kunt opzoeken, is het een feit.",
          "2": "Je dacht waarschijnlijk dat dit een mening is. Maar 'het WK 2022 was in Qatar' is een controleerbaar historisch feit. Onthoud: historische gebeurtenissen zijn feiten.",
          "3": "Je dacht waarschijnlijk dat dit een mening is. Maar 'een voetbalteam bestaat uit 11 spelers' is een controleerbaar feit — het staat in de spelregels. Onthoud: regels en aantallen zijn feiten."
        }
      }
    },
    {
      "id": "TAA-LEZEN-FEIT-002",
      "familyId": "TAA-LEZEN-FEIT",
      "module": "Taalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_feit_mening",
      "questionType": "multiple_choice",
      "question": "Een onderzoeker schrijft een rapport. Welke zin is een feit?",
      "options": ["De aarde draait om de zon.", "Zonsondergangen zijn het mooiste natuurverschijnsel.", "Iedereen zou meer naar buiten moeten gaan.", "De zomer is het fijnste seizoen."],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Feit herkennen", "content": "Een feit is iets dat bewezen of gecontroleerd kan worden. 'De aarde draait om de zon' is wetenschappelijk bewezen. Meningen bevatten woorden als 'het mooiste', 'het fijnste', 'zou moeten'.", "icon": "lightbulb" } }],
      "conceptId": "fact_identification",
      "variantIndex": 2,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "FEIT-MENING-OVERTR-TRAP", "optionIndex": 1, "label": "Herkent overtreffende trap niet als meningssignaal" },
          { "id": "FEIT-MENING-ZOU-MOETEN", "optionIndex": 2, "label": "Herkent 'zou moeten' niet als meningssignaal" },
          { "id": "FEIT-MENING-SUPERLATIVE", "optionIndex": 3, "label": "Herkent 'het fijnste' niet als waardeoordeel" }
        ]
      },
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "De onderzoeker weet: een feit is objectief controleerbaar — je kunt het bewijzen of opzoeken. 'De aarde draait om de zon' is wetenschappelijk bewezen → feit. De andere zinnen bevatten waardeoordelen: 'het mooiste', 'zou moeten', 'het fijnste' → meningen.",
        "solutionSteps": ["Bekijk elke zin: is het controleerbaar?", "'De aarde draait om de zon' → wetenschappelijk bewezen → feit", "'Het mooiste', 'zou moeten', 'het fijnste' → waardeoordelen → meningen"],
        "distractorExplanations": {
          "0": "Goed! 'De aarde draait om de zon' is een wetenschappelijk bewezen feit.",
          "1": "Je dacht waarschijnlijk dat dit een feit is. Maar 'het mooiste natuurverschijnsel' bevat de overtreffende trap → waardeoordeel → mening. Niet iedereen vindt zonsondergangen het mooiste. Onthoud: overtreffende trap = mening.",
          "2": "Je dacht waarschijnlijk dat dit een feit is. Maar 'zou moeten' geeft een persoonlijke overtuiging aan → mening. Het is niet objectief bewezen dat iedereen meer naar buiten moet. Onthoud: 'zou moeten' = mening.",
          "3": "Je dacht waarschijnlijk dat dit een feit is. Maar 'het fijnste seizoen' bevat de overtreffende trap → waardeoordeel → mening. Niet iedereen vindt de zomer het fijnst. Onthoud: overtreffende trap = mening."
        }
      }
    },
    {
      "id": "TAA-LEZEN-FEIT-003",
      "familyId": "TAA-LEZEN-FEIT",
      "module": "Taalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_feit_mening",
      "questionType": "multiple_choice",
      "question": "Een historicus schrijft een artikel. Welke zin bevat zowel een feit als een mening?",
      "options": ["Amsterdam heeft 900.000 inwoners en is de mooiste stad van Nederland.", "De Rijn stroomt door Duitsland en Nederland.", "Ik vind dat het te koud is in de winter.", "Katten zijn de beste huisdieren."],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Feit én mening in één zin", "content": "Soms staan feit en mening in dezelfde zin. Het feit: '900.000 inwoners' (controleerbaar). De mening: 'de mooiste stad' (waardeoordeel). Let op het signaalwoord 'mooiste'.", "icon": "lightbulb" } }],
      "conceptId": "fact_opinion_combined",
      "variantIndex": 3,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "FEIT-MENING-TWEE-FEITEN", "optionIndex": 1, "label": "Verwart twee feiten in één zin met feit+mening" },
          { "id": "FEIT-MENING-IK-VIND-GEEN-FEIT", "optionIndex": 2, "label": "Denkt dat 'ik vind' automatisch feit+mening maakt" },
          { "id": "FEIT-MENING-STERKE-BEWERING", "optionIndex": 3, "label": "Verwart sterke bewering met feit+mening" }
        ]
      },
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "De historicus herkent: splits de zin in delen en beoordeel elk deel apart. '900.000 inwoners' → controleerbaar getal → feit. 'De mooiste stad' → overtreffende trap, waardeoordeel → mening. Eén zin kan dus zowel een feit als een mening bevatten.",
        "solutionSteps": ["Splits de zin in delen", "'Amsterdam heeft 900.000 inwoners' → controleerbaar → feit", "'de mooiste stad van Nederland' → overtreffende trap → mening", "Beide in één zin → feit + mening"],
        "distractorExplanations": {
          "0": "Goed! '900.000 inwoners' is een feit, 'de mooiste stad' is een mening. Beide in één zin.",
          "1": "Je dacht waarschijnlijk dat elke zin met twee delen feit + mening bevat. Maar 'De Rijn stroomt door Duitsland en Nederland' bevat alleen feiten — beide delen zijn controleerbaar. Onthoud: twee feiten in één zin is ook mogelijk.",
          "2": "Je dacht waarschijnlijk dat 'ik vind' automatisch een feit + mening maakt. Maar 'ik vind dat het te koud is' is volledig een mening — 'te koud' is subjectief. Onthoud: er zit geen controleerbaar feit in.",
          "3": "Je dacht waarschijnlijk dat een sterke bewering een feit bevat. Maar 'de beste huisdieren' is volledig een mening (overtreffende trap). Onthoud: er zit geen controleerbaar feit in."
        }
      }
    },
    {
      "id": "TAA-LEZEN-FEIT-004",
      "familyId": "TAA-LEZEN-FEIT",
      "module": "Taalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_feit_mening",
      "questionType": "multiple_choice",
      "question": "Een redacteur controleert een tekst. Welk signaalwoord wijst op een mening?",
      "options": ["volgens mij", "ten eerste", "bijvoorbeeld", "namelijk"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Signaalwoorden bij meningen", "content": "Meningen herken je aan signaalwoorden als: 'volgens mij', 'ik vind', 'naar mijn idee', 'het beste', 'het mooiste'. 'Ten eerste', 'bijvoorbeeld' en 'namelijk' zijn signaalwoorden voor opsomming, voorbeeld en uitleg.", "icon": "lightbulb" } }],
      "conceptId": "opinion_signal_words",
      "variantIndex": 4,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "SIGNAAL-OPSOMMING-VS-MENING", "optionIndex": 1, "label": "Verwart opsommingssignaalwoord met meningssignaalwoord" },
          { "id": "SIGNAAL-VOORBEELD-VS-MENING", "optionIndex": 2, "label": "Verwart voorbeeldsignaalwoord met meningssignaalwoord" },
          { "id": "SIGNAAL-UITLEG-VS-MENING", "optionIndex": 3, "label": "Verwart uitlegsignaalwoord met meningssignaalwoord" }
        ]
      },
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "De redacteur weet: meningen worden vaak ingeleid door woorden die aangeven dat het een persoonlijk standpunt is. 'Volgens mij' geeft aan dat er een persoonlijke mening volgt. De andere opties zijn signaalwoorden voor andere tekstverbanden: opsomming, voorbeeld, uitleg.",
        "solutionSteps": ["Bekijk elk signaalwoord: wijst het op een persoonlijk standpunt?", "'Volgens mij' → persoonlijk standpunt → meningssignaalwoord", "'Ten eerste' → opsomming, 'bijvoorbeeld' → voorbeeld, 'namelijk' → uitleg"],
        "distractorExplanations": {
          "0": "Goed! 'Volgens mij' is een signaalwoord dat aangeeft dat er een persoonlijke mening volgt.",
          "1": "Je dacht waarschijnlijk dat 'ten eerste' een meningssignaalwoord is. Maar 'ten eerste' is een signaalwoord voor opsomming (ten eerste, ten tweede, ten derde). Onthoud: opsommingswoorden ≠ meningswoorden.",
          "2": "Je dacht waarschijnlijk dat 'bijvoorbeeld' een meningssignaalwoord is. Maar 'bijvoorbeeld' introduceert een voorbeeld, geen mening. Onthoud: voorbeeldwoorden ≠ meningswoorden.",
          "3": "Je dacht waarschijnlijk dat 'namelijk' een meningssignaalwoord is. Maar 'namelijk' geeft een toelichting of uitleg, geen mening. Onthoud: uitlegwoorden ≠ meningswoorden."
        }
      }
    },
    {
      "id": "TAA-LEZEN-FEIT-005",
      "familyId": "TAA-LEZEN-FEIT",
      "module": "Taalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_feit_mening",
      "questionType": "multiple_choice",
      "context": "Een leerling schrijft in een werkstuk: 'De Tweede Wereldoorlog duurde van 1939 tot 1945. Het was de verschrikkelijkste oorlog ooit.'",
      "question": "Een wetenschapper leest het werkstuk. Welk deel van de tekst is een mening?",
      "options": ["Het was de verschrikkelijkste oorlog ooit.", "De Tweede Wereldoorlog duurde van 1939 tot 1945.", "Beide zinnen zijn feiten.", "Beide zinnen zijn meningen."],
      "correctAnswer": 0,
      "stimulusAids": [{ "type": "readingPassage", "data": { "passage": "De Tweede Wereldoorlog duurde van 1939 tot 1945. Het was de verschrikkelijkste oorlog ooit.", "instruction": "Lees het werkstuk" } }],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Feit vs. mening in een werkstuk", "content": "De eerste zin bevat data (1939–1945) die je kunt controleren → feit. De tweede zin bevat 'de verschrikkelijkste ooit' — dat is een waardeoordeel → mening.", "icon": "lightbulb" } }],
      "conceptId": "fact_opinion_in_text",
      "variantIndex": 5,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "FEIT-MENING-DATA-IS-FEIT", "optionIndex": 1, "label": "Verwart controleerbare data met mening" },
          { "id": "FEIT-MENING-WERKSTUK-ALLES-FEIT", "optionIndex": 2, "label": "Denkt dat alles in een werkstuk een feit is" },
          { "id": "FEIT-MENING-ALLES-MENING", "optionIndex": 3, "label": "Denkt dat alles een mening is" }
        ]
      },
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "De wetenschapper beoordeelt elke zin apart. '1939 tot 1945' → historische data, controleerbaar → feit. 'De verschrikkelijkste oorlog ooit' → overtreffende trap + 'ooit' → waardeoordeel → mening. Dit is niet objectief meetbaar. Ook in werkstukken kunnen meningen staan die eruitzien als feiten.",
        "solutionSteps": ["Beoordeel elke zin apart", "'1939 tot 1945' → controleerbare data → feit", "'De verschrikkelijkste ooit' → overtreffende trap → mening", "De mening is de tweede zin"],
        "distractorExplanations": {
          "0": "Goed! 'De verschrikkelijkste oorlog ooit' is een waardeoordeel (overtreffende trap + 'ooit') → mening.",
          "1": "Je dacht waarschijnlijk dat de eerste zin de mening is. Maar 'van 1939 tot 1945' is juist een controleerbaar historisch feit. De mening is de andere zin. Onthoud: data en jaartallen zijn feiten.",
          "2": "Je dacht waarschijnlijk dat alles in een werkstuk een feit is. Maar de tweede zin bevat het waardeoordeel 'de verschrikkelijkste ooit' → dat is een mening. Onthoud: ook in werkstukken staan meningen.",
          "3": "Je dacht waarschijnlijk dat alles een mening is. Maar de eerste zin bevat controleerbare historische data (1939–1945) → dat is een feit. Onthoud: jaartallen en data zijn altijd feiten."
        }
      }
    },
    {
      "id": "TAA-LEZEN-FEIT-009",
      "familyId": "TAA-LEZEN-FEIT",
      "module": "Taalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_feit_mening",
      "questionType": "true_false_series",
      "question": "Zijn deze stellingen een feit of een mening?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          { "text": "De aarde draait om de zon.", "isTrue": true },
          { "text": "Zomer is het leukste seizoen.", "isTrue": false },
          { "text": "Water kookt bij 100 graden Celsius.", "isTrue": true },
          { "text": "Iedereen houdt van chocolade.", "isTrue": false }
        ]
      },
      "conceptId": "fact_opinion_series",
      "variantIndex": 9,
      "pedagogy": { "dok": 2 },
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Een feit is controleerbaar en objectief. Een mening is subjectief en bevat een waardeoordeel.",
        "solutionSteps": ["De aarde draait om de zon is wetenschappelijk bewezen (feit)", "Zomer is het leukste seizoen is een waardeoordeel (mening)", "Water kookt bij 100 graden is natuurkundig bewezen (feit)", "Iedereen houdt van chocolade is niet waar voor iedereen (mening)"]
      }
    },
    {
      "id": "TAA-LEZEN-FEIT-010",
      "familyId": "TAA-LEZEN-FEIT",
      "module": "Taalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_feit_mening",
      "questionType": "true_false_series",
      "question": "Zijn deze stellingen een feit of een mening?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          { "text": "De Eiffeltoren staat in Parijs.", "isTrue": true },
          { "text": "Parijs is de mooiste stad van Europa.", "isTrue": false },
          { "text": "Een jaar heeft 365 of 366 dagen.", "isTrue": true },
          { "text": "Honden zijn betere huisdieren dan katten.", "isTrue": false }
        ]
      },
      "conceptId": "fact_opinion_series_2",
      "variantIndex": 10,
      "pedagogy": { "dok": 2 },
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Een feit is controleerbaar en objectief. Een mening is subjectief en bevat een waardeoordeel.",
        "solutionSteps": [
          "De Eiffeltoren staat in Parijs is controleerbaar (feit)",
          "Parijs is de mooiste stad is een waardeoordeel (mening)",
          "Een jaar heeft 365/366 dagen is controleerbaar (feit)",
          "Honden zijn betere huisdieren is een waardeoordeel (mening)"
        ]
      }
    }
  ]
}